module.exports = __webpack_public_path__ + "static/img/Upmood Mass Set up and Insight.0c76391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/Upmood Mass Set up and Insight.png
// module id = RL9x
// module chunks = 3